import type { PGD } from "../types";

export const pgdErythromycinSinusitis: PGD = {
  id: "pgd-6f-eryth-sinusitis",
  reference: "6f",
  version: "1.0",
  drugRef: "erythromycin",
  indication: "Acute sinusitis — penicillin allergy and pregnant, age 16 years or over",
  validFrom: "2024-01-31",
  expiryDate: "2027-01-30",
  frameworkType: "pharmacy_first",
  population: {
    ageRange: { min: 16, max: 999 },
    pregnancyAllowed: true,
    breastfeedingAllowed: true,
  },
  duration: { days: 5 },
  doseBands: [
    {
      id: "eryth-sinusitis-age16plus",
      resolveBy: "single",
      ageRange: { min: 16, max: 999 },
      dose: 500,
      frequency: "FOUR times a day",
      formulations: [
        { formulationId: "eryth-500-tab", instruction: "Take ONE 500mg tablet FOUR times a day for 5 days", quantity: { count: 20, label: "20 tablets" } },
        { formulationId: "eryth-250-tab", instruction: "Take TWO 250mg tablets FOUR times a day for 5 days", quantity: { count: 40, label: "40 tablets" } },
        { formulationId: "eryth-500-5ml", instruction: "Take 5mL (500mg) FOUR times a day for 5 days", quantity: { bottles: 1, label: "1 × 100mL bottle" } },
        { formulationId: "eryth-250-5ml", instruction: "Take 10mL (500mg) FOUR times a day for 5 days", quantity: { bottles: 2, label: "2 × 100mL bottles" } },
        { formulationId: "eryth-125-5ml", instruction: "Take 20mL (500mg) FOUR times a day for 5 days", quantity: { bottles: 4, label: "4 × 100mL bottles" } },
      ],
    },
  ],
  preSupplyChecks: [
    { id: "ex-consent-refused", question: "Has the patient/carer refused consent?" },
    { id: "ex-unable-swallow", question: "Unable to absorb oral medications and/or unable to swallow oral dosage formulations?" },
    { id: "ex-failed-abx", question: "Failed previous antibiotic for this episode of sinusitis?" },
    { id: "ex-long-term-macrolide", question: "Currently on long-term clarithromycin, erythromycin, azithromycin or another macrolide?" },
    { id: "ex-qt", question: "Known QT prolongation, congenital long QT syndrome, or history of ventricular arrhythmia?", linkRefs: ["crediblemeds-qt", "sads-drugs-avoid"] },
    { id: "ex-electrolytes", question: "Uncorrected hypokalaemia or hypomagnesaemia?" },
    { id: "ex-severe-liver", question: "Severe hepatic impairment?" },
    { id: "int-qt-drugs", question: "Taking medicines known to prolong QT interval?", linkRefs: ["crediblemeds-qt", "sads-drugs-avoid"] },
    { id: "int-statin", question: "Taking simvastatin or lovastatin?" },
    { id: "int-colchicine", question: "Taking colchicine?" },
    { id: "int-warfarin", question: "Taking warfarin or another coumarin anticoagulant?" },
  ],
  cautions: [
    { id: "caution-pregnancy", text: "Pregnancy — erythromycin is used when clinically appropriate; provide safety netting and routine pregnancy advice." },
    { id: "caution-gi", text: "Gastrointestinal adverse effects are common." },
  ],
  counselling: [
    "Take just before or with food",
    "Tablets should be swallowed whole",
    "Complete the full 5-day course even if symptoms improve",
    "Seek advice if palpitations, syncope, severe diarrhoea, jaundice or allergic symptoms occur",
  ],
  counsellingPoints: [
    { text: "Take just before or with food" },
    { text: "Tablets should be swallowed whole" },
    { text: "Complete the full 5-day course even if symptoms improve" },
    { text: "Seek advice if palpitations, syncope, severe diarrhoea, jaundice or allergic symptoms occur" },
  ],
  outcomeLinkRefs: ["target-rti-leaflet", "nhs-sinusitis"],
};
